import React, { FC, lazy, Suspense } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import Home from "../client/pages/Home";
import { Loader } from "../components/UI/Loader";
import { ProtectedRoute } from "./ProtectedRoute";
import { AdminRoute } from "./AdminRoute";
import { update as updateIntercom } from "../config/intercom";

const Login = lazy(() => import("../client/pages/Login"));
const Settings = lazy(() => import("../client/pages/Settings"));
const Register = lazy(() => import("../client/pages/Register"));
const Forgotten = lazy(() => import("../client/pages/Forgotten"));
const Buy = lazy(() => import("../client/pages/Buy"));
const Sell = lazy(() => import("../client/pages/Sell"));
const Orders = lazy(() => import("../client/pages/Orders"));
const ResetPassword = lazy(() => import("../client/pages/ResetPassword"));
const AdminLogin = lazy(() => import("../admin/pages/AdminLogin"));
const NotFound = lazy(() => import("../client/pages/Notfound"));
const Dashboard = lazy(() => import("../admin/pages/Dashboard"));
const BuyOrders = lazy(() => import("../admin/pages/Buys"));
const SellOrders = lazy(() => import("../admin/pages/Sells"));

export const Routes: FC = () => {
  const { listen } = useHistory();
  listen(() => {
    updateIntercom();
  });
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/register">
            <Register />
          </Route>
          <Route exact path="/forgotten">
            <Forgotten />
          </Route>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/reset-password">
            <ResetPassword />
          </Route>
          <Route exact path="/admin">
            <AdminLogin />
          </Route>
          <ProtectedRoute path="/user/buy" component={Buy} />
          <ProtectedRoute path="/user/sell" component={Sell} />
          <ProtectedRoute path="/user/orders" component={Orders} />
          <ProtectedRoute path="/user/settings" component={Settings} />
          <AdminRoute component={Dashboard} path="/admin/dashboard" />
          <AdminRoute component={BuyOrders} path="/admin/buy" />
          <AdminRoute component={SellOrders} path="/admin/sell" />
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Suspense>
    </>
  );
};
